module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded_categorias == 'true') ? _c('div', {
    staticClass: "col-xs-12 npd block novedades"
  }, [(_vm.loaded_categorias == 'true') ? _c('ul', {
    staticClass: "col-xs-12 filtro"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'allcats'
      }
    }
  }, [_vm._v("\n\t\t\t\tTodos\n\t\t\t")])], 1), _vm._v(" "), _vm._l((_vm.categorias), function(categoria) {
    return _c('li', {
      staticClass: "_active"
    }, [(categoria.slug != 'podcast') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'cat',
          params: {
            name: categoria.slug
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(categoria.name) + "\n\t\t\t")]) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.categorias), function(categoria) {
    return _c('section', {
      staticClass: "col-xs-12 npd novedades__bloque"
    }, [(categoria.slug != 'podcast') ? _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 npd novedades__categoria"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('h3', [_vm._v(" " + _vm._s(categoria.name) + "  ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6 text-right"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'cat',
          params: {
            name: categoria.slug
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\tVer todo >\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), (_vm.loaded_all == 'true') ? _c('div', {
      staticClass: "col-xs 12"
    }, _vm._l((_vm.posts[categoria.id]), function(post) {
      return _c('div', {
        staticClass: "col-xs-6 col-md-3"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'post',
            params: {
              name: post.slug
            }
          }
        }
      }, [(post.better_featured_image != null) ? _c('figure', [(post.better_featured_image.media_details.sizes.hasOwnProperty('536x516')) ? _c('img', {
        attrs: {
          "src": post.better_featured_image.media_details.sizes['536x516'].source_url
        }
      }) : _c('img', {
        attrs: {
          "src": post.better_featured_image.source_url
        }
      })]) : _c('figure', [_c('img', {
        attrs: {
          "src": 'http://via.placeholder.com/536x516/008AD2/dddddd?text=' + post.title.rendered,
          "alt": ""
        }
      })]), _vm._v(" "), _c('h3', {
        domProps: {
          "innerHTML": _vm._s(post.title.rendered)
        }
      }, [_vm._v("aaaa")]), _vm._v(" "), _c('p', {
        domProps: {
          "innerHTML": _vm._s(post.soloexcerpt)
        }
      }, [_vm._v("aaaa")])])], 1)
    })) : _vm._e()])]) : _vm._e()])
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aaa6fac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/allcats.vue
// module id = 132
// module chunks = 0